import React, { useState, useEffect, useCallback } from 'react';
import * as S from './styles';
import api from '../../../../../services/api';
import { toastSuccess, toastError } from '../../../../../toasts';
import { EditShedule } from '../EditShedule';
import { useAuth } from '../../../../../hooks/auth';
import { FaEdit, FaTrash, FaPlus, FaClock } from 'react-icons/fa';
import { daysLabels } from '../../../../../constants/daysLabels';
import { Toggle, Loader, Modal, Button } from 'rsuite';
import { CustomButton } from '../../../../../components/CustomButton';

export const Schedules = ({ isUsing, groupId, setGrupo, setGrupos }) => {
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [scheduleToAction, setScheduleToAction] = useState({});
  const [loading, setLoading] = useState(false);
  const [toggling, setToggling] = useState(false);

  const { id_empresa: companyId } = useAuth();

  const getSchedules = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`horarios-grupo/listar-grupo/${groupId}`);
      setSchedules(data);
    } catch (error) {
      console.error(error);
      toastError('Não foi possível carregar os horários');
    } finally {
      setLoading(false);
    }
  }, [groupId]);

  const handleUseShedules = async (checked) => {
    setToggling(true);
    const using = checked ? 1 : 0;

    try {
      await api.patch(`grupo-produto/alterar/${groupId}`, {
        UsaHorario: using,
      });

      setGrupo((prev) => ({ ...prev, UsaHorario: using }));
      setGrupos((prev) =>
        prev.map((g) => (g.Id !== groupId ? g : { ...g, UsaHorario: using })),
      );

      if (using === 1) {
        getSchedules();
      }

      toastSuccess(`Horários ${using ? 'ativados' : 'desativados'} com sucesso`);
    } catch (error) {
      console.error(error);
      toastError('Não foi possível alterar a configuração');
    } finally {
      setToggling(false);
    }
  };

  const handleEditSchedule = (_schedule) => {
    setScheduleToAction(_schedule);
    setIsModalEditOpen(true);
  };

  const confirmDelete = (_schedule) => {
    setScheduleToAction(_schedule);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteSchedule = async () => {
    try {
      await api.delete(`horarios-grupo/${scheduleToAction.Id}`);
      toastSuccess('Horário removido com sucesso');
      setIsDeleteModalOpen(false);
      getSchedules();
    } catch (error) {
      toastError('Erro ao remover horário');
    }
  };

  const handleOpenModal = () => {
    if (isModalEditOpen) {
      setScheduleToAction({});
    }
    setIsModalEditOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isUsing) {
      getSchedules();
    }
  }, [isUsing, getSchedules]);

  return (
    <S.Container>
      <S.Header>
        <S.ToggleContainer>
          <Toggle
            checkedChildren="Ativo"
            unCheckedChildren="Inativo"
            checked={!!isUsing}
            onChange={handleUseShedules}
            loading={toggling}
          />
          <S.Label>Utilizar restrição de horários neste grupo</S.Label>
        </S.ToggleContainer>

        {!!isUsing && (
          <CustomButton
            onClick={handleOpenModal}
            startIcon={<FaPlus />}
            size="sm"
            appearance="primary"
          >
            Novo Horário
          </CustomButton>
        )}
      </S.Header>

      {!!isUsing && (
        <S.ContentContainer>
          {loading ? (
            <S.LoadingWrapper>
              <Loader content="Carregando horários..." />
            </S.LoadingWrapper>
          ) : schedules.length > 0 ? (
            <S.Grid>
              {schedules.map((item) => (
                <S.ScheduleCard key={item.Id}>
                  <S.ScheduleInfo>
                    <S.DayLabel>{daysLabels[item?.Day]}</S.DayLabel>
                    <S.TimeLabel>
                      <FaClock size={12} style={{ marginRight: 5 }} />
                      {item.Start} às {item.End}
                    </S.TimeLabel>
                  </S.ScheduleInfo>

                  <S.Actions>
                    <S.ActionButton onClick={() => handleEditSchedule(item)} title="Editar">
                      <FaEdit size={16} />
                    </S.ActionButton>
                    <S.ActionButton onClick={() => confirmDelete(item)} title="Excluir" isDelete>
                      <FaTrash size={16} />
                    </S.ActionButton>
                  </S.Actions>
                </S.ScheduleCard>
              ))}
            </S.Grid>
          ) : (
            <S.EmptyState>
              Nenhum horário configurado. O grupo ficará sempre disponível.
            </S.EmptyState>
          )}
        </S.ContentContainer>
      )}

      <EditShedule
        open={isModalEditOpen}
        handleClose={handleOpenModal}
        schedule={scheduleToAction}
        setSchedule={setScheduleToAction}
        getSchedules={getSchedules}
        groupId={groupId}
        companyId={companyId}
      />

      <Modal open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} size="xs">
        <Modal.Header>
          <Modal.Title>Excluir Horário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja remover o horário de <strong>{daysLabels[scheduleToAction?.Day]}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setIsDeleteModalOpen(false)} appearance="subtle">
            Cancelar
          </Button>
          <Button onClick={handleDeleteSchedule} appearance="primary" color="red">
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </S.Container>
  );
};
